function IconHappyClients() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" fill="none" aria-hidden="true">
      <circle cx="22" cy="22" r="6" stroke="currentColor" strokeWidth="3" />
      <circle cx="42" cy="22" r="6" stroke="currentColor" strokeWidth="3" />
      <circle cx="32" cy="14" r="5" stroke="currentColor" strokeWidth="3" />
      <path d="M14 46C14 38 18 34 22 34C26 34 30 38 30 46" stroke="currentColor" strokeWidth="3" />
      <path d="M34 46C34 38 38 34 42 34C46 34 50 38 50 46" stroke="currentColor" strokeWidth="3" />
    </svg>
  )
}

function IconSuccessfulOrders() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" fill="none" aria-hidden="true">
      <rect x="16" y="12" width="32" height="40" rx="4" stroke="currentColor" strokeWidth="3" />
      <path d="M24 22H40" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
      <path d="M24 30H36" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
      <path d="M26 42L32 48L42 36" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
    </svg>
  )
}

function IconCountriesServed() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" fill="none" aria-hidden="true">
      <circle cx="32" cy="32" r="22" stroke="currentColor" strokeWidth="3" />
      <path d="M10 32H54" stroke="currentColor" strokeWidth="3" />
      <path d="M32 10C40 18 40 46 32 54" stroke="currentColor" strokeWidth="3" />
      <path d="M32 10C24 18 24 46 32 54" stroke="currentColor" strokeWidth="3" />
    </svg>
  )
}

function IconYearGrowth() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" fill="none" aria-hidden="true">
      <path d="M12 50H52" stroke="currentColor" strokeWidth="3" />
      <path d="M20 50V36" stroke="currentColor" strokeWidth="4" strokeLinecap="round" />
      <path d="M32 50V28" stroke="currentColor" strokeWidth="4" strokeLinecap="round" />
      <path d="M44 50V18" stroke="currentColor" strokeWidth="4" strokeLinecap="round" />
      <path
        d="M18 22L30 14L40 20L52 10"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M46 10H52V16" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
    </svg>
  )
}

export const achievementsCommitmentIcons = {
  clients: IconHappyClients,
  orders: IconSuccessfulOrders,
  countries: IconCountriesServed,
  growth: IconYearGrowth,
}
